import {
  createShouldForwardProp,
  props,
} from '@styled-system/should-forward-prop'

const shouldForwardProp = createShouldForwardProp([
  ...props,
  'transform',
  'uppercase',
  'verticalCenter',
  'center',
  'horizontalCenter',
])

export default shouldForwardProp
